module.exports = __webpack_public_path__ + "static/media/logo-white.39bf9401.svg";